import { useQuery } from '@tanstack/react-query';
import { surveyAuditApi } from '../api/surveyAuditApi';
import { surveyAuditQueryKeys } from './queryKeys';
import { UseAuditQuestionsOptions } from '../types';

// Hook for getting audit questions
export const useAuditQuestions = (auditId: string, options?: UseAuditQuestionsOptions) => {
  return useQuery({
    queryKey: surveyAuditQueryKeys.questions(auditId),
    queryFn: () => surveyAuditApi.getAuditQuestions(auditId),
    enabled: options?.enabled !== false && !!auditId,
    staleTime: 5 * 60 * 1000, // 5 minutes - questions don't change frequently
  });
};

// Hook for getting responses for a specific question
export const useQuestionResponses = (auditId: string, questionId: string, enabled = true) => {
  return useQuery({
    queryKey: surveyAuditQueryKeys.questionResponses(auditId, questionId),
    queryFn: () => surveyAuditApi.getQuestionResponses(auditId, questionId),
    enabled: enabled && !!auditId && !!questionId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

// Hook for checking audit permissions
export const useAuditPermissions = (userId: string, subjectId: string, enabled = true) => {
  return useQuery({
    queryKey: surveyAuditQueryKeys.permissions(userId, subjectId),
    queryFn: () => surveyAuditApi.checkAuditPermissions(userId, subjectId),
    enabled: enabled && !!userId && !!subjectId,
    staleTime: 10 * 60 * 1000, // 10 minutes - permissions don't change frequently
  });
};
